<template>
   <modal-component
      :active="showModalTest"
      @cancel="closeModalTest"
      @accept="closeModalTest"
      :titleModal="'Test webhook'"
      textSave="Aceptar"
      :withoutCancel="true"
      :isMessage="false"
      :isConfirm="true"
    >
      <div>
        <div class="columns is-multiline" v-if="!loadingTest">
          <div class="column is-6">
            <div class="field">
              <label class="label"><span class="has-text-weight-bold">Evento:</span> {{ eventName }}</label>
            </div>
          </div>
        <div class="column is-6">
          <div class="field">
            <label class="label"><span class="has-text-weight-bold">URL:</span> {{ webhookUrl }}</label>
          </div>
        </div>
        <div class="column is-12">
            <div class="field">
              <label class="label has-text-weight-bold">Headers:</label>
              <div class="control">
                <div class="json-block" id="jsonBlock">{{ webhookHeader }}</div>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="field">
              <label class="label"><span class="has-text-weight-bold">Response:</span> <small
                  :class="(statusCode === 500 || statusCode === 502 || statusCode === 400) ? 'response-error' : 'response-success'">Error ({{ statusCode }})</small></label>
              <div class="control">
                <div class="json-block" id="jsonBlock">{{ respBody }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="has-text-centered" v-else>
          <div class="lds-dual-ring"></div>
        </div>
      </div>
    </modal-component>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
export default {
  name: 'Webhooks',
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  mixins: [mixins],
  props: {
    showModalTest: {
      type: Boolean,
      default: false
    },
    closeModalTest: {
      type: Function,
      default: () => {}
    },
    eventName: {
      type: String,
      default: ''
    },
    webhookUrl: {
      type: String,
      default: ''
    },
    webhookHeader: {
      type: String,
      default: ''
    },
    statusCode: {
      type: Number,
      default: null
    },
    respBody: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      loadingTest: false,
      role: {},
      error: ''
    }
  },
  methods: {
    ...mapActions([])
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    })
  },
  mounted () {
  }

}
</script>

<style lang="scss" scoped>
.json-block {
  border-radius: 6px;
  padding: 1rem;
  font-size: 14px;
  white-space: pre;
  overflow-x: auto;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  position: relative;
}
.response-success {
  color: green;
}
.response-error {
  color: red;
}
</style>
